import React from 'react';
import MaintenanceBanner from '../../components/maintenance/MaintenanceBanner';

const MaintenancePage: React.FC = () => {
    return (
        <div style={{
            padding: 24,
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
        }}>
            <MaintenanceBanner />
        </div>
    );
};

export default MaintenancePage;
